/**
 * Manifest settings.
 *
 * @remarks
 * - Center : formulaire de réglages dynamique
 * - Left tab : navigation entre catégories
 * - Right tab : tips contextuels
 * - Bouton d'accès : engrenage en bas du rail latéral (cf. `navigation`).
 */

import { Lightbulb, ListTree, Settings as SettingsIcon } from 'lucide-react';
import { commandBus } from '@/app/commands/command-bus';
import type { FeatureManifest } from '@/app/registry';
import { CONTEXTS, lazyView } from '@/app/registry';
import { settingsRoutes } from './routes';

export const settingsManifest: FeatureManifest = {
  id: 'settings',
  contexts: [CONTEXTS.SETTINGS],

  routes: [{ routes: settingsRoutes, errorFallbackLabel: 'Paramètres' }],

  centerView: {
    [CONTEXTS.SETTINGS]: lazyView(() => import('./views/SettingsFormView'), 'SettingsFormView'),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.SETTINGS]: [
          {
            id: 'settings-nav',
            label: 'Catégories',
            icon: ListTree,
            view: lazyView(
              () => import('./views/SettingsNavigationView'),
              'SettingsNavigationView',
            ),
          },
        ],
      },
    },
    right: {
      tabs: {
        [CONTEXTS.SETTINGS]: [
          {
            id: 'settings-tips',
            label: 'Conseils',
            icon: Lightbulb,
            view: lazyView(() => import('./views/SettingsTipsView'), 'SettingsTipsView'),
          },
        ],
      },
    },
  },

  navigation: [
    {
      id: 'settings',
      label: 'Paramètres',
      icon: SettingsIcon,
      to: '/settings',
      position: 'bottom',
      order: 30,
    },
  ],

  shortcuts: [
    {
      id: 'settings:open',
      keys: 'mod+,',
      label: 'Ouvrir les paramètres',
      scope: 'global',
      handler: () => {
        commandBus.emit('shell:navigate', '/settings');
      },
    },
  ],

  panelRequirements: {
    [CONTEXTS.SETTINGS]: {
      left: { open: true, defaultActiveTab: 'settings-nav' },
      right: { open: true, defaultActiveTab: 'settings-tips' },
    },
  },
};
